









































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import PrintTable from "@/basics/table/PrintTable.vue";
import formatDate from "@/lib/formatDate";
import QR from "qrcode";

@Component({
  components: {
    CButton,
    PrintTable
  }
})
export default class AppAccountQRcode extends Vue {
  svg = "";

  get start(): string {
    const u = Number(this.$route.query.start);
    return formatDate(new Date(u));
  }

  get end(): string {
    const u = Number(this.$route.query.end);
    return formatDate(new Date(u));
  }

  get name(): string {
    return this.$route.query.name as string;
  }

  get password(): string {
    return this.$route.query.password as string;
  }

  get id(): string {
    return this.$route.query.id as string;
  }

  print() {
    window.print();
  }

  async mounted() {
    const json = JSON.stringify({ password: this.password, id: this.id });
    this.svg = await QR.toString(json, {
      width: 600,
    });
  }
}
